import { Injectable } from '@angular/core';

@Injectable()
export class CookieService {

  cookieData:any = {};

  constructor() { }

  get(k){
    return this.cookieData[k]
  }

  // set value for multi level key
  _set_multi(k1,k2,v){
    this.cookieData[k1][k2] = v
  }


  set(k,v){
    this.cookieData[k] = v
  }

  deleteAll(){
    this.cookieData = {}
  }

}



// WEBPACK FOOTER //
// ./src/app/data-worker/cookie.service.ts